export const menuData = [
    { title: 'Hem', link: '/' },
    // { title: 'Klubbens historia', link: '/klubbens-historia' },
    // { title: 'Värdegrund', link: '/vardegrund' },
    { title: 'Djurgården Bordtennis', link: '/djurgarden-bordtennis' },
    { title: 'Pingisskolor', link: '/pingisskolor' },
    { title: 'Klubbdräkt', link: '/klubbdrakt' },
    { title: 'Lagen', link: '/lagen' },
    { title: 'Värdegrund', link: '/vardegrund' }
];